import { register } from '|>/shared/vjs'
import { BaseMediaLoader, BaseMuteToggle, BaseResizeManager } from '../base'
import { ChildrenSlot } from '../children-slot'
import { DebugOverlay } from '../debug-overlay'
import { ErrorHandler } from '../error-handler'
import { defaultPlayer } from './default-player'
import { Player } from './player'

import './trailer-player.css'

/**
 * Trailer player - Player without unnecessary children for trailer playback
 */
@register
class TrailerPlayer extends Player {}

// Override options to exclude unnecessary children.
// `smartRestart: false` opts this preview/background player out of Tria
// Smart-Restart recovery (FP-4169); full-page `?trailer` uses defaultPlayer.
TrailerPlayer.options = {
  smartRestart: false,
  children: [
    // `MediaLoader` decides which playback technology to load when a player is initialized
    BaseMediaLoader.as(),

    // debug overlay with stream and player info
    DebugOverlay,

    // empty slot for children elements rendering
    ChildrenSlot.as('slot'),

    // component to track size of the player
    BaseResizeManager.as(),

    // volume bar
    BaseMuteToggle.as('muteToggle.vjs-x-mute-control'),

    // intercept HTTP errors
    ErrorHandler,
  ],
}

export const trailerPlayer = TrailerPlayer.as(
  `${defaultPlayer.className}.vjs-x-player-trailer`,
  []
)
